import React from 'react';
import './about.css';
import aboutMedia from '../../assets/mockup/about_media.jpg';
import Cert from '../../assets/ISO_9001_2015_sr.pdf';
import { useTranslation } from 'react-i18next';

function About() {
  const { t } = useTranslation('global');
  return (
    <section
      className="band-section band-section--photo band-section--about"
      id="about"
      aria-labelledby="about-title"
      style={{ '--band-photo': `url(${aboutMedia})` }}
    >
      <div className="band-section__photo" aria-hidden="true" />
      <div className="band-section__grid bm-container">
        <div className="glass-panel glass-panel--on-photo glass-panel--edge-right">
          <h2 id="about-title">{t('about.about')}</h2>
          <p className="glass-panel__brand">BeoMedica</p>
          <div className="glass-panel__body">
            <p>{t('about.paragraph_1')}</p>
            <p>{t('about.paragraph_2')}</p>
            <p>
              {t('about.paragraph_3')}{' '}
              <a
                className="glass-panel__link"
                target="_blank"
                rel="noopener noreferrer"
                href={Cert}
              >
                ISO 9001:2015
              </a>
            </p>
          </div>
        </div>
        <div className="band-media band-media--right band-media--spacer" aria-hidden="true" />
      </div>
    </section>
  );
}

export default About;
